module.exports = __webpack_public_path__ + "img/热门配图-1-221x183.0e13be03.png";